import BoxItem from './BoxItem';
import './BoxItem.scss';

export default BoxItem;
